<div class="w-100 h-100 form">
  <h4 class="text-center">{{titleData.id ? 'Editar' : 'Crear'}}</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-5">
      <div >
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título Principal</mat-label>
          <input matInput placeholder="Título Principal" [(ngModel)]="this.titleData.title" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-2">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <mat-select [(ngModel)]="titleData.orderId">
          <!--            <mat-option [value]="cardInfo.orderId">{{cardInfo.orderId}}</mat-option>-->
          <mat-option *ngFor="let cards of orderOpts; index as i" [value]=" i + 1">{{i + 1}}</mat-option>
        </mat-select>
      </mat-form-field>
<!--      <mat-button-toggle-group [(ngModel)]="titleData.orderId" aria-label="order" [value]="titleData.orderId" *ngIf="titleData.id">-->
<!--        <mat-button-toggle *ngFor="let option of titleData.all; index as i" [value]="i + 1">{{i + 1}}</mat-button-toggle>-->
<!--      </mat-button-toggle-group>-->
<!--      <mat-button-toggle-group [(ngModel)]="titleData.orderId" aria-label="order" [value]="titleData.orderId" *ngIf="!titleData.id">-->
<!--        <mat-button-toggle *ngFor="let option of orderOpts; index as i" [value]="i + 1">{{i + 1}}</mat-button-toggle>-->
<!--      </mat-button-toggle-group>-->
    </div>
    <div class="col-5 text-end">
      <button mat-mini-fab aria-label="Add Link" class="save-button" matTooltip="Crear Link"
              (click)="createLinkFields()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div class="col-12">
      <div class="mb-3 max-height">
        <div *ngFor="let link of titleData.titleVirtual, index as i">
          <div class="row ">
            <div class="col-6">
              <mat-form-field appearance="outline" class="w-100 me-4">
                <mat-label>Título</mat-label>
                <input matInput placeholder="Título de Link" [(ngModel)]="link.title" required>
                <mat-error>Este campo es <b>Requerido</b></mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-button-toggle-group [(ngModel)]="link.status" aria-label="order" [value]="link.status">
                <mat-button-toggle value="Activo">Activo</mat-button-toggle>
                <mat-button-toggle value="Desactivado">Desactivado</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div class="col-2">
              <button class="mt-2" mat-icon-button (click)="deleteLinkField(i)">
                <mat-icon color="warn">delete</mat-icon>
              </button>
            </div>

<!--            <mat-form-field appearance="outline" class="w-100">-->
<!--              <mat-label>URL de link</mat-label>-->
<!--              <input matInput placeholder="URL de Link" [(ngModel)]="link.url" required>-->
<!--              <mat-error>Este campo es <b>Requerido</b></mat-error>-->
<!--            </mat-form-field>-->


          </div>
        </div>
      </div>
      <div class="mx-3 d-flex justify-content-center">
      </div>
    </div>
  </div>


  <div class="bottom-button">
    <button class="vs-btn-blue" (click)="sendData()" >
      Guardar
    </button>
  </div>

</div>
